import { timezoneZodSchema } from '@/lib/time-zones.js';
import { internationalPhoneRegex } from '@/lib/string-utils.js';
import { CreateUserOptions } from '@airreading/common/data';
import { z } from 'zod';

export const createCoachSchema = z.object({
  firstName: z.string().min(1, { message: 'First name is required' }),
  lastName: z.string().min(1, { message: 'Last name is required' }),
  email: z.string().email({ message: 'Invalid email format' }),
  phone: z.string().min(1, { message: 'Phone is required' }).regex(internationalPhoneRegex, {
    message: 'Phone number must be in international format (e.g. +1, +54)',
  }),
  smsReminderOptedIn: z.boolean().default(true),
  timeZone: timezoneZodSchema,
  displayName: z.string().optional(),
  secondaryEmail: z.string().email({ message: 'Invalid email format' }).optional().or(z.literal('')),
});
export type CreateCoachFormSchema = z.infer<typeof createCoachSchema>;

export function createUserOptionsFromFormData({
  firstName,
  lastName,
  email,
  phone,
  timeZone,
}: CreateCoachFormSchema): CreateUserOptions {
  return {
    firstName,
    lastName,
    email,
    phone,
    assignRoles: [],
    timeZone: timeZone.value,
  };
}
